import { useMedia } from 'react-use';

// @deprecated
export const useIsDesktop = () => {
  return useMedia('(min-width: 992px)', true);
};
